/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/7-websites-you-need-to-use-as-a-developer",
  title: "7 websites you need to use as a developer",
  description: `7 websites you need to use as a developer

A thread🧵

👇`,
  image: "/covers/threads/7-websites-you-need-to-use-as-a-developer.png",
  author: "Vlad Pasca👨‍💻"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ol: "ol",
    li: "li",
    ul: "ul",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Vlad Pasca👨‍💻",
      username: "VladPasca5",
      avatarUrl: "/avatars/VladPasca5.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/VladPasca5/status/1370011627613872130"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "7 websites you need to use as a developer"
      }), _jsx(_components.p, {
        children: "A thread🧵"
      }), _jsx(_components.p, {
        children: "👇"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "GitHub"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "I am sure that it needs no introduction for most developers."
      }), _jsx(_components.p, {
        children: "Why use GitHub?"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Share your code with others"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "It's a skill every developer should have"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Host your static websites for free using GitHub Pages"
          }), "\n"]
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Link - ", _jsx(_components.a, {
          href: "https://github.com/",
          children: "https://github.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsx(_components.li, {
          children: "Heroku"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "It is used to deploy, manage, and scale modern apps."
      }), _jsx(_components.p, {
        children: "Why use Heroku?"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "They offer a free trial and you can host dynamic applications in Rails, PHP, Node.js, and Python web applications."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Modern and easy to use"
          }), "\n"]
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Link - ", _jsx(_components.a, {
          href: "https://www.heroku.com/",
          children: "https://www.heroku.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsx(_components.li, {
          children: "Digital Ocean"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Digital Ocean is a hosting provider in which you can host your servers, databases, etc."
      }), _jsx(_components.p, {
        children: "Why use Digital Ocean?"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "You can work on personal projects and want an easy to use interface."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "You can keep things as simple as possible."
          }), "\n"]
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Link - ", _jsx(_components.a, {
          href: "https://cloud.digitalocean.com/login",
          children: "https://cloud.digitalocean.com/login"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsx(_components.li, {
          children: "Daily.dev"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Get the hottest dev news from the best tech blogs on any topic you can think of."
      }), _jsx(_components.p, {
        children: "You'll no longer need to check every blogging platform. Daily. dev has them all"
      }), _jsx(_components.p, {
        children: "Why use @dailydotdev ?"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Stay updated daily"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Save time"
          }), "\n"]
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Link - ", _jsx(_components.a, {
          href: "https://daily.dev/",
          children: "https://daily.dev/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsx(_components.li, {
          children: "Figma"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Design, prototype, and gather feedback all in one place."
      }), _jsx(_components.p, {
        children: "Why use Figma?"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Easy to use"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Excellent design"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Prototyping"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Code-generation tools"
          }), "\n"]
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Link - ", _jsx(_components.a, {
          href: "https://www.figma.com/",
          children: "https://www.figma.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "6",
        children: ["\n", _jsx(_components.li, {
          children: "Codewars"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Become a better developer by practicing different coding problems."
      }), _jsx(_components.p, {
        children: "Why use Codewars?"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Get out of your comfort zone"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Learn by practicing"
          }), "\n"]
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Link - ", _jsx(_components.a, {
          href: "https://www.codewars.com/",
          children: "https://www.codewars.com/"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.ol, {
        start: "7",
        children: ["\n", _jsx(_components.li, {
          children: "Glassdoor"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "A website where current and former employees anonymously review companies."
      }), _jsx(_components.p, {
        children: "Why use Glassdoor?"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "You can find out what it is like working for the company."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "You can find out how much are the employees paid in the company."
          }), "\n"]
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["Link - ", _jsx(_components.a, {
          href: "https://www.glassdoor.com/index.htm",
          children: "https://www.glassdoor.com/index.htm"
        })]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "The end of this thread🧵"
      }), _jsx(_components.p, {
        children: "Thanks for reading, I hope you found it useful."
      }), _jsx(_components.p, {
        children: "If you did make sure you follow me on Twitter @VladPasca5 for more tweets about improving as a developer, web development, and coding in general."
      }), _jsx(_components.p, {
        children: "What would add to this list?👇"
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
